import React, { Fragment } from 'react';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';
import Hero3 from '../components/Hero3/Hero3';
import SocialProof from '../components/SocialProof/SocialProof';
import Content from '../components/Content/Content';
import Benefits from '../components/Benefits/Benefits';
import CTA from '../components/CTA/CTA';
import Gallery from '../components/Gallery/Gallery';
import Process from '../components/Process/Process';
import FAQs from '../components/FAQs/FAQs';
import SEO from '../components/SEO/SEO';
import { Helmet } from 'react-helmet-async';

type RentaCajasSecasProps = {}

const RentaCajasSecas:React.FC<RentaCajasSecasProps> = (props: RentaCajasSecasProps) => {
  return (
    <Fragment>
      <SEO 
        title="Grupo GM | Renta de plataformas en Hidalgo"
        description="En Grupo GM nos especializamos en la renta de plataformas para el transporte de mercancías en Hidalgo. Ofrecemos soluciones logísticas flexibles y adaptadas a las necesidades de tu empresa."
        canonicalUrl="https://grupo-gm.mx/renta-plataformas-hidalgo"
      />
      <Navbar fixedScrolled={true} contactRibbon={true} />
      <Hero3 />
      <SocialProof />
      <Benefits
        title="¿Por qué rentar tus plataformas con nosotros en Hidalgo?"
        description="Aquí hay algunas razones por las cuales nuestros clientes nos dan su confianza para la renta de plataformas"
        variant='secondary'
        slots={[
          {
            title: 'Entrega inmediata',
            content: 'Contamos con una flota activa de más de 50 plataformas disponibles para entrega inmediata, listas para integrarse a tu operación sin generar tiempos muertos.'
          },
          {
            title: 'Plataformas en perfecto estado',
            content: 'Todos nuestros equipos reciben mantenimiento constante y revisiones periódicas para garantizar un funcionamiento seguro, eficiente y confiable durante toda tu operación.'
          },
          {
            title: 'Mantenimiento incluido',
            content: 'Esto te dará tranquilidad ya que no tendrás que gestionar el mantenimiento y tendrás la garantía que las plataformas estén en condiciones óptimas.'
          },
          {
            title: 'Ubicación estratégica en Hidalgo',
            content: 'Nuestra ubicación en Hidalgo nos permite atender con rapidez a empresas y transportistas en todo el centro del país, reduciendo costos y tiempos de traslado del equipo.'
          },
          {
            title: 'Atención rápida y personalizada',
            content: 'Brindamos atención directa vía llamada o WhatsApp, con respuesta inmediata y asesoría personalizada para ayudarte a elegir el equipo más adecuado según tu tipo de carga.'
          },
        ]}
      />
      <Process 
        title="Proceso de renta de plataformas"
        description="Nuestro proceso de renta de plataformas es rápido, claro y sin complicaciones. Te acompañamos paso a paso, desde la confirmación de disponibilidad hasta la entrega del equipo en Hidalgo, garantizando un servicio eficiente y confiable para tu operación."
        steps={[
          {
            icon: (
              <svg className="h-5 w-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7h6l2 4m-8-4v8m0-8V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v9h2m8 0H9m4 0h2m4 0h2v-4m0 0h-5m3.5 5.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm-10 0a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z"></path>
              </svg>
            ),
            title: 'Confirma disponibilidad de plataforma',
            description: 'Verificamos en tiempo real el equipo disponible según tus necesidades de capacidad y ubicación.'
          },
          {
            icon: (
              <svg className="h-5 w-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 3v4a1 1 0 0 1-1 1H5m4 6 2 2 4-4m4-8v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1Z"></path>
              </svg>
            ),
            title: 'Envía tus datos y documentos',
            description: 'Compártenos la información necesaria para agilizar el proceso de renta y validación.'
          },
          {
            icon: (
              <svg className="h-5 w-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 11.917 9.724 16.5 19 7.5"></path>
              </svg>
            ),
            title: 'Recibe y acepta tu cotización',
            description: 'Te enviamos una propuesta clara, sin costos ocultos, lista para aprobación.'
          },
          {
            icon: (
              <svg className="h-5 w-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m4 12 8-8 8 8M6 10.5V19a1 1 0 0 0 1 1h3v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3h3a1 1 0 0 0 1-1v-8.5"></path>
              </svg>
            ),
            title: 'Programa la entrega en Hidalgo',
            description: 'Coordinamos fecha y lugar para que recibas tu plataforma de forma puntual.'
          }
        ]}
      />
      <CTA 
        title="Servicio profesional de renta de plataformas en Hidalgo" 
        description="Grupo GM ofrece renta de plataformas en Hidalgo, con equipos en excelente estado y atención profesional. Brindamos soluciones confiables y rápidas para transporte y logística. Si buscas servicio seguro y eficiente, Grupo GM es tu mejor opción."
        buttonText="Cotizar ahora"
      />
      <Gallery 
        title="Equipos disponibles"
        description="Explora nuestra galería de plataformas disponibles y conoce el estado, capacidades y características de cada equipo. Todas nuestras unidades se encuentran listas para trabajar y cumplir con tus necesidades de transporte y logística."
        buttonText="Verificar disponibilidad"
        images={[
          {
            src: "https://grupogm-assets.s3.us-east-1.amazonaws.com/renta-plataformas/plataforma1.webp",
            alt: "Plataforma disponible 1"
          },
          {
            src: "https://grupogm-assets.s3.us-east-1.amazonaws.com/renta-plataformas/plataforma2.webp",
            alt: "Plataforma disponible 2"
          },
          {
            src: "https://grupogm-assets.s3.us-east-1.amazonaws.com/renta-plataformas/plataforma3.webp",
            alt: "Plataforma disponible 3"
          }
        ]}
      />
      <Content
        title='Renta de plataformas en todo Hidalgo'
        description='Operamos en todo el estado de Hidalgo y zonas clave del centro del país, ofreciendo disponibilidad constante de equipos y atención rápida donde tu operación lo necesite.'
      />
      <FAQs
        slots={[
          {
            title: '¿Cuánto cuesta rentar una plataforma en Hidalgo?',
            content: 'Contamos con una flota activa de más de 50 plataformas disponibles para entrega inmediata, listas para integrarse a tu operación sin generar tiempos muertos.'
          },
          {
            title: '¿Puedo rentar por una semana?',
            content: 'Todos nuestros equipos reciben mantenimiento constante y revisiones periódicas para garantizar un funcionamiento seguro, eficiente y confiable durante toda tu operación.'
          },
          {
            title: '¿Entregan en mi municipio?',
            content: 'Esto te dará tranquilidad ya que no tendrás que gestionar el mantenimiento y tendrás la garantía que las plataformas estén en condiciones óptimas.'
          },
          {
            title: '¿Qué capacidad tienen?',
            content: 'Nuestra ubicación en Hidalgo nos permite atender con rapidez a empresas y transportistas en todo el centro del país, reduciendo costos y tiempos de traslado del equipo.'
          },
          {
            title: '¿Qué necesito para contratar?',
            content: 'Brindamos atención directa vía llamada o WhatsApp, con respuesta inmediata y asesoría personalizada para ayudarte a elegir el equipo más adecuado según tu tipo de carga.'
          },
        ]}  
      />
      <Footer />
    </Fragment>
  )
}

export default RentaCajasSecas;